import { Component, OnInit, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';

// from company
import { environment } from '../environments/environment';

// declare const ENV_VARS_AS_JSON: any;
// const ENV_VARS = JSON.parse(ENV_VARS_AS_JSON);
// const process: any = { env: ENV_VARS, };

@Component({
    selector: 'app-root',
    imports: [RouterOutlet],
    templateUrl: './app.component.html',
    styleUrl: './app.component.css'
})
export class AppComponent
{
    private titleService = inject(Title);

    constructor()
    {
        const link = document.createElement('link');
        link.rel = 'icon';
        link.type = 'image/png';
        // link.href = `${environment.CDN_URL}/public/_app/features/generic/logo/013-envheaven-logo-02@0.25x.png`;
        link.href = `${environment.WEB_SITE_01_CDN_01_FULL_URL}/public/_app/features/generic/logo/013-envheaven-logo-02@0.25x.png`;
        document.head.appendChild(link);

        this.titleService.setTitle(environment.WEB_SITE_01_FE_01_PUBLIC_NAME);

        // console.log('ENV_VARS = ', ENV_VARS);
        // console.log('process.env = ', process.env);
    }
}
